import { useState } from "react";
import "./NewFooter.scss";
import { Image, Row, Col, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookSquare, faYoutube, faInstagram, faTwitter, faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faSearchLocation, faPhoneAlt, faPhoneSquareAlt, faMobile, faMobileAlt } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
const logo = "./asessts/images/logo/logo.png";
const instagram = "./asessts/images/instagram.png";

function NewMobileFooter() {
  const master = "../../asessts/images/master.png";
  const visa = "../../asessts/images/visa.png";
  const paypal = "../../asessts/images/paypal.png";
  const stripeImage = "../../asessts/images/stripe.png";

  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div id="mobileFooter">
      <a target="_blank" href="https://wa.me/447354473871" id="whatsapp">
        <img src="../../asessts/images/whatsapp.png" />
      </a>
      <div className="mobileFooter-details">
        <div className="d-flex justify-content-center">
          {/* <img src="../../../asessts/images/logo/logo.png" /> */}
        </div>
        <div className="accordion">
          <div className="acc-1">
            <div className="d-flex justify-content-between"   onClick={() => handleToggle(0)}>
              <h5 style={{ color: "black" }} className={`text-black ${openIndex === 0 ? "fw-bold" : ""}`}>Address</h5>
              <h5>{openIndex === 0 ? "-" : "+"}</h5>
            </div>
            {openIndex === 0 && (
              <div>
                <div>
                  <p className="text-black opacity-75" style={{ fontSize: "0.9rem", wordSpacing: "4px", lineHeight: "23px" }}>
                    <FontAwesomeIcon icon={faSearchLocation} />
                    &nbsp; Office # 1 G-Floor Building #43, Street # 9 Shama Road, Ichhra Lahore, Punjab 54600
                  </p>
                  <p className="text-black opacity-75" style={{ fontSize: "0.9rem", wordSpacing: "4px", lineHeight: "23px" }}>
                    <FontAwesomeIcon icon={faSearchLocation} />
                    &nbsp;   93 Bennetts Castle Lane, Dagenham, England, RM8 3YB
                  </p>
                  <p style={{ fontSize: "0.9rem", wordSpacing: "4px", lineHeight: "23px" }}>
                    <FontAwesomeIcon icon={faEnvelope} />{" "}
                    <a className="text-decoration-none text-black opacity-75" href="mailto:info@wellcreator.com">
                      info@wellcreator.com
                    </a>
                  </p>

                  <div className="d-flex">
                    <p className="pe-3" style={{ fontSize: "0.9rem", wordSpacing: "4px", lineHeight: "23px" }}>
                      <FontAwesomeIcon icon={faPhoneAlt} />{" "}
                      <a className="text-decoration-none text-black opacity-75" href="tel:042 37583100">
                        042-37583100
                      </a>
                    </p>
                    <p style={{ fontSize: "0.9rem", wordSpacing: "4px", lineHeight: "23px" }}>
                      <FontAwesomeIcon icon={faMobileAlt} />{" "}
                      <a className="text-decoration-none text-black opacity-75" href="tel: 0323 4022301">
                        {" "}
                        0323-4022301
                      </a>
                    </p>
                  </div>
                  {/* <h5 className="text-color mt-5 text-start">Follow us on</h5> */}
                  <p className="pe-3" style={{ fontSize: "0.9rem", wordSpacing: "4px", lineHeight: "23px" }}>
                    <FontAwesomeIcon icon={faPhoneAlt} />{" "}
                    <a className="text-decoration-none text-black opacity-75" href="tel:+447354473871">
                      +44 7354 473871
                    </a>
                  </p>
                </div>
                <div className="mt-2">
                  <p className="text-start ps-2 text-black opacity-75" style={{ fontSize: "0.9rem", wordSpacing: "4px", lineHeight: "1.7", fontWeight:"bold" }}>
                    "Design, Develop & Deploy."
                    <br />
                    <span>
                      <b>By Wellcreator</b>
                    </span>
                  </p>
                </div>
              </div>
                 )}
          </div>
          <div className="acc-1">
            <div className="d-flex justify-content-between"  onClick={() => handleToggle(1)}>
              <h5 style={{ color: "black" }} className={`text-black ${openIndex === 1 ? "fw-bold" : ""}`}>Become a Creator</h5>
              <h5>{openIndex === 1 ? "-" : "+"}</h5>
            </div>
            {openIndex === 1 && (
              <div>
                <div className="d-flex flex-column  mb-3">
                  <Link className="text-decoration-none text-black opacity-75" to="/blog" style={{ fontSize: "0.9rem", lineHeight: "30px", wordSpacing: "4px", fontWeight: "400" }}>
                    Blog
                  </Link>
                  <Link className="text-decoration-none text-black opacity-75" to="/portfolio" style={{ fontSize: "0.9rem", lineHeight: "30px", wordSpacing: "4px", fontWeight: "400" }}>
                    Portfolio
                  </Link>
                  <Link className="text-decoration-none text-black opacity-75" to="//Referral-Program"  style={{ fontSize: "0.9rem", lineHeight: "30px", wordSpacing: "4px", fontWeight: "400" }}>Referral Program</Link>
                  <Link className="text-decoration-none text-black opacity-75" to="" style={{ fontSize: "0.9rem", lineHeight: "30px", wordSpacing: "4px", fontWeight: "400" }}></Link>
                  <Link className="text-decoration-none text-black opacity-75" to="/hrm" style={{ fontSize: "0.9rem", lineHeight: "30px", wordSpacing: "4px", fontWeight: "400" }}>
                    Products
                  </Link>
                </div>
              </div>
              )}
          </div>
          <div className="acc-1">
            <div className="d-flex justify-content-between"  onClick={() => handleToggle(2)}>
              <h5 style={{ color: "black" }} className={`text-black ${openIndex === 2 ? "fw-bold" : ""}`}>Services</h5>
              <h5>{openIndex === 2 ? "-" : "+"}</h5>
            </div>
            {openIndex === 2 && (
              <div>
                <div className="d-flex flex-column ">
                  <Link
                    to="/website-development"
                    className="py-1 text-decoration-none text-black opacity-75" style={{ fontSize: '0.9rem', lineHeight: '23px', wordSpacing: '4px', fontWeight: '400' }}
                  >
                    Website Development
                  </Link>{" "}
                  <Link
                    to="/custom-software-development-services"
                    className="py-1 text-decoration-none text-black opacity-75" style={{ fontSize: '0.9rem', lineHeight: '23px', wordSpacing: '4px', fontWeight: '400' }}
                  >
                    Software Development
                  </Link>
                  <Link
                    to="/unity-game-development-company"
                    className="py-1 text-decoration-none text-black opacity-75" style={{ fontSize: '0.9rem', lineHeight: '23px', wordSpacing: '4px', fontWeight: '400' }}
                  >
                    Unity Development
                  </Link>
                  <Link
                    to="/mobile-development"
                    className="py-1 text-decoration-none text-black opacity-75" style={{ fontSize: '0.9rem', lineHeight: '23px', wordSpacing: '4px', fontWeight: '400' }}
                  >
                    Mobile App Development
                  </Link>

                  <Link
                    to="/affordable-seo-services-uk"
                    className="py-1 text-decoration-none text-black opacity-75" style={{ fontSize: '0.9rem', lineHeight: '23px', wordSpacing: '4px', fontWeight: '400' }}
                  >
                    Search Engine Optimization
                  </Link>
                   <Link
                    to="/shopify-development-services"
                    className="py-1 text-decoration-none text-black opacity-75" style={{ fontSize: '0.9rem', lineHeight: '23px', wordSpacing: '4px', fontWeight: '400' }}
                  >
                    Shopify Devleopment Services
                  </Link>
                   {/* <Link
                    to="/DigitalMarketing"
                    className="py-1 text-decoration-none acc-1" style={{ fontSize: '0.9rem', lineHeight: '23px', wordSpacing: '4px', fontWeight: '400' }}
                  >
                    Digital Marketing
                  </Link> */}
                  <Link
                    to="/wordpress-development-services"
                    className="py-1 text-decoration-none text-black opacity-75" style={{ fontSize: '0.9rem', lineHeight: '23px', wordSpacing: '4px', fontWeight: '400' }}
                  >
                    Wordpress Development Services
                  </Link>
                  <Link
                    to="/.Net-development-services"
                    className="py-1 text-decoration-none text-black opacity-75" style={{ fontSize: '0.9rem', lineHeight: '23px', wordSpacing: '4px', fontWeight: '400' }}
                  >
                    .Net Devlopment
                  </Link> 

                </div>
              </div>    )}
          </div>
          <div className="acc-1">
            <div className="d-flex justify-content-between" >
              <h5 style={{ color: "black" }}><Link to="/about-us" style={{textDecoration:"none" , color :"black"}}>About Us</Link></h5>
          </div>
          </div>
          <div className="acc-1">
            <div className="d-flex justify-content-between"    onClick={() => handleToggle(3)}>
              <h5 style={{ color: "black" }} className={`text-black ${openIndex === 3 ? "fw-bold" : ""}`}>Others</h5>
              <h5>{openIndex === 3 ? "-" : "+"}</h5>
            </div>
            {openIndex === 3 && (
              <div className="d-flex flex-column mb-2">
                <Link
                  className="text-decoration-none acc-1"
                  to="/contact-us"
                  style={{ fontSize: '0.9rem', lineHeight: '30px', wordSpacing: '4px', fontWeight: '400' }}
                >
                  Contact us
                </Link>

                <Link
                  className="text-decoration-none acc-1"
                  to="/faqs"
                  style={{ fontSize: '0.9rem', lineHeight: '30px', wordSpacing: '4px', fontWeight: '400' }}
                >
                  FAQs
                </Link>
                <Link
                  className="text-decoration-none acc-1"
                  to="/"
                  style={{ fontSize: '0.9rem', lineHeight: '30px', wordSpacing: '4px', fontWeight: '400' }}
                >
                  Domain Registeration
                </Link>
                <Link
                  className="text-decoration-none acc-1"
                  to="/"
                  style={{ fontSize: '0.9rem', lineHeight: '30px', wordSpacing: '4px', fontWeight: '400' }}
                >
                  Wordpress Hosting
                </Link>
                <Link
                  className="text-decoration-none text-black opacity-75"
                  to="/qutation"
                  style={{ fontSize: '0.9rem', lineHeight: '30px', wordSpacing: '4px', fontWeight: '400' }}
                >
                  Qutation
                </Link>
              </div>)}
          </div>
          <div className="acc-1">
            <div className="d-flex justify-content-between"    onClick={() => handleToggle(4)}>
              <h5 style={{ color: "black" }} className={`text-black ${openIndex === 4 ? "fw-bold" : ""}`}>Customer Services</h5>
              <h5>{openIndex === 4 ? "-" : "+"}</h5>
            </div>
            {openIndex === 4 && (
              <div className="d-flex flex-column mb-2">
                <Link style={{ fontSize: '0.9rem', lineHeight: '23px', wordSpacing: '4px', fontWeight: '400' }} to="/contact-us" className="py-1 text-decoration-none acc-1" >
                  Contact Us
                </Link>

                <Link
                  className="text-decoration-none acc-1"
                  to="/qutation"
                  style={{ fontSize: '0.9rem', lineHeight: '30px', wordSpacing: '4px', fontWeight: '400' }}
                >
                  Qutation
                </Link>
              </div>)}
          </div>
          <div className="acc-1">
            <div className="d-flex justify-content-between"    onClick={() => handleToggle(5)}>
              <h5 style={{ color: "black" }} className={`text-black ${openIndex === 5 ? "fw-bold" : ""}`}>Newsletter</h5>
              <h5>{openIndex === 5 ? "-" : "+"}</h5>
            </div>
            {openIndex === 5 && (
              <div className="d-flex flex-column">
                <Form className="mt-3">
                  <p>Level up your game and stay tuned for promotions.</p>
                  <Form.Group controlId="formBasicEmail">
                    <Form.Control className="bg-light p-2 px-3 text-center shadow-sm border-light" type="email" placeholder="Enter email" />
                  </Form.Group>
                  <button className="btn mt-2 sub-btn text-white">SUBSCRIBE</button>
                </Form>
              </div>
            )}
          </div>
          <Row className="my-2 mt-3 d-flex justify-content-center">

            <Col xs={2} className="text-center" >
              <a target="_blank" href="https://www.facebook.com/wellcreator">

                <FontAwesomeIcon icon={faFacebookSquare} style={{ fontSize: '2rem' }} />
              </a>
            </Col>
            <Col xs={2} className="text-center" >
              <a target="_blank" href="https://github.com/wellcreator">

                <FontAwesomeIcon icon={faGithub} style={{ color: "#282828", fontSize: '2rem' }} />
              </a>
            </Col>
            <Col xs={2} className="text-center">
              <a target="_blank" href="https://twitter.com/wellcreator">

                <FontAwesomeIcon
                  style={{ color: "00acee", fontSize: '2rem' }}
                  icon={faTwitter}
                />
              </a>
            </Col>
            <Col xs={2} className="text-center">
              <a target="_blank" href="https://www.instagram.com/wellcreator/">

                <FontAwesomeIcon
                  style={{ color: "#E1306C", fontSize: '2rem' }}
                  icon={faInstagram}
                />
              </a>
            </Col>
            <Col xs={2} className="text-center">
              <a target="_blank" href="https://www.youtube.com/channel/UCMYAfqVrzCDHOvlHJ1paIsw">

                <FontAwesomeIcon
                  style={{ color: "#FF0000", fontSize: '2rem' }}
                  icon={faYoutube}
                />
              </a>
            </Col>
            <Col xs={2} className="text-center">
              <a target="_blank" href="https://www.linkedin.com/company/wellcreator/">
                {" "}
                <FontAwesomeIcon
                  style={{ color: "#1666C2", fontSize: '2rem' }}
                  icon={faLinkedin}
                />
              </a>
            </Col>
          </Row>
          <div className="border d-flex justify-content-center py-2">
            <Image className="payment mx-3" style={{ width: 'auto', height: '30px', objectFit: 'contain' }} src={visa} />
            <Image className="payment mx-3" style={{ width: 'auto', height: '30px', objectFit: 'contain' }} src={master} />
            <Image className="payment mx-3" style={{ width: 'auto', height: '30px', objectFit: 'contain' }} src={paypal} />
            <Image className="payment mx-3" style={{ width: 'auto', height: '30px', objectFit: 'contain' }} src={stripeImage} />
          </div>
          <div className="footer-foot m-0 text-center d-flex justify-content-between mt-3 mb-lg-0 flex-md-row flex-column">
            <div className="d-flex flex-wrap justify-content-center">
              <Link style={{ color: ' #000000', fontSize: '13px' }} className="  px-1" to="/sitemap">Sitemap|</Link>{" "}

              <Link style={{ color: ' #000000', fontSize: '13px' }} className="  " to="/career">Career|</Link>{" "}

              <Link style={{ color: ' #000000', fontSize: '13px' }} className=" px-1" to="/terms-conditions">Terms & Condition |&nbsp;</Link>{" "}

              <Link style={{ color: ' #000000', fontSize: '13px' }} className=" " to="/privacy-policy">Privacy Policy</Link>{" "}

              <Link style={{ color: ' #000000', fontSize: '13px' }} className=" " to="/RefundPolicy">| Re-Fund Policy</Link>{" "}

            </div>
            <p className="foot-laste align-self-center mb-0" style={{ fontSize: '13px' }}>
              © Wellcreator 2012 - 2025. All Rights Reserved.
            </p>

          </div>
        </div>
      </div>
    </div>
  );
}

export default NewMobileFooter;
